import TagSelector from '@app/components/tag-selector/tag-selector';
import { useFilterItemContext } from '@app/hocs/search/filter/filter-item-context';

export const TagFilter = () => {
  const { value, onChange } = useFilterItemContext<number[]>();
  return (
    <TagSelector
      value={value}
      onChange={onChange}
    />
  );
};
